import { seoHead } from "@/lib/seo";

export function marketingHead({
  title,
  description,
  path,
  noindex,
}: {
  title: string;
  description: string;
  path: string;
  /** For product pages whose feature is not live yet. */
  noindex?: boolean;
}) {
  return seoHead({
    title,
    description,
    canonicalPath: path,
    noindex,
  });
}
